<template>
  <el-tabs class="common-tabs" v-model="activeName" @tab-click="handleTabClick">
  <el-tab-pane label="数据上传" name="tabUpload" v-if="userMenu.indexOf('数据上传') >= 0"></el-tab-pane>
  <el-tab-pane label="数据下载" name="tabDown" v-if="userMenu.indexOf('数据下载') >= 0">
  <div id="myDnload">
    <div class="allBody">
      <!-- <nav class="allTop">
        <img src="../../../assets/home01.png" width="100%" height="60"/>
        <div>数据下载</div>
      </nav> -->
      <div class="sytmgDiv">
        <div>
          <!--<span  @click="toUrl(item)" :class="parseInt(menuNum) === parseInt(item.id) ? 'onUhSpan' : ''" :key="index" v-for="(item, index) in systemMenu">{{ item.name }}</span>-->
          <span  @click="toUrl({url: 'myDnloadHome', id: 1})" :class="menuNum === 1 ? 'onUhSpan' : ''">数据下载</span>
          <span @click="toUrl({url: 'myOneSuCriberList', id: 2})" :class="menuNum === 2 ? 'onUhSpan' : ''">个人订阅记录</span>
          <span v-if="userMenu.indexOf('全部订阅记录') >= 0" @click="toUrl({url: 'myAllSuCriberList', id: 3})" :class="menuNum === 3 ? 'onUhSpan' : ''">全部订阅记录</span>
          <span  @click="toUrl({url: 'myOneDnloadTaskList', id: 4})" :class="menuNum === 4 ? 'onUhSpan' : ''">个人下载任务记录</span>
          <span v-if="userMenu.indexOf('全部下载任务记录') >= 0" @click="toUrl({url: 'myAllDnloadTaskList', id: 5})" :class="menuNum === 5 ? 'onUhSpan' : ''">全部下载任务记录</span>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
   </el-tab-pane>
  <el-tab-pane label="系统管理" name="tabSystem" v-if="userMenu.indexOf('系统管理') >= 0"></el-tab-pane>
</el-tabs>
</template>

<script>
let timeMenu
export default {
  name: 'myDnload',
  data () {
    return {
      activeName: 'tabDown',
      userMenu: this.$userMenu,
      systemMenu: [
        {
          id: 1,
          name: '数据下载',
          url: 'myDnloadHome',
          activeUrl: 'myDnloadHomemyDnloadHomeDetail',
          showMenu: true
        },
        {
          id: 2,
          name: '个人订阅记录',
          url: 'myOneSuCriberList',
          activeUrl: 'myOneSuCriberList',
          showMenu: true
        },
        {
          id: 3,
          name: '全部订阅记录',
          url: 'myAllSuCriberList',
          activeUrl: 'myAllSuCriberList',
          showMenu: false
        },
        {
          id: 4,
          name: '个人下载任务记录',
          url: 'myOneDnloadTaskList',
          activeUrl: 'myOneDnloadTaskList',
          showMenu: true
        },
        {
          id: 5,
          name: '全部下载任务记录',
          url: 'myAllDnloadTaskList',
          activeUrl: 'myAllDnloadTaskList',
          showMenu: false
        }
      ],
      menuNum: 1
    }
  },
  created () {
    timeMenu = setInterval(p => {
      if ('myDnloadHomemyDnloadHomeDetail'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 1
      } else if ('myOneSuCriberList'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 2
      } else if ('myAllSuCriberList'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 3
      } else if ('myOneDnloadTaskList'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 4
      } else if ('myAllDnloadTaskList'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 5
      }
    }, 100)
  },
  destroyed () {
    clearInterval(timeMenu)
  },
  mounted () {
  },
  methods: {
    handleTabClick () {
      if (this.activeName === 'tabUpload') {
        this.$router.push({name: 'index'})
      } else if (this.activeName === 'tabSystem') {
        this.$router.push({name: 'mySystemMessager'})
      }
    },
    // returnShowMenu (item) {
    //   item.showMenu = true
    //   if (item.id === 3 || item.id === 5) {
    //     item.showMenu = false
    //     if (this.userMenu.indexOf(item.name) >= 0) {
    //       item.showMenu = true
    //     }
    //   }
    //   return item.showMenu
    // },
    toUrl (item) {
      this.menuNum = item.id
      this.$router.push({
        name: item.url
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myDnload.vue